import React from 'react';

export function EditButton({testId, onClick, disabled}) {
  function getClassName() {
    if (disabled) {
      return 'prequal--web--modify-button-disabled';
    }
    return 'prequal--web--modify-button-fomo';
  }

  return (
    <button type='button' data-testid={testId} onClick={onClick} className={getClassName()} disabled={disabled}>
      <span className='prequal--web--pen-icon-fomo' /> Edit
    </button>
  );
}
